import { DatenauswertungFormWrapper } from './DatenauswertungFormWrapper';
import { DatenauswertungGenerisch } from './DatenauswertungGenerisch';
import { DatenauswertungJahrauswahl } from './DatenauswertungJahrauswahl';
import { DatenauswertungReportKonfigurationBemerkungButton } from './DatenauswertungReportKonfigurationBemerkungButton';
import datenauswertungStyle from './datenauswertung.less'
import { fn2, fn2nZ } from '../../core/formatter/formatNumber';
import { getRoutingEnergiedaten } from '../../helpers/getRoutingEnergiedaten';
import { getStandorteGruppenTabRoutings } from '../dateneingabe/functions/StandorteGruppen';
// import { getStyle } from './generisch/DatanauswertungGenerischStyles';
import { i18n } from '../../i18n/i18n';
import { IDs } from '../../helpers/IDs';
import { isVeranstaltung } from '../../helpers/getVeranstaltungen';
import * as React from 'react';
import { RoutingIDs } from '../../helpers/RoutingIDs';
import { rowHasValues } from './generisch/renderRows';
import { SectionStyle } from '../../helpers/SectionStyle';
import { StandortAuswahl } from './elements/StandortAuswahl';
import { WActionButton } from '../../core/elements/WActionButton';
import { WHelpIcon } from '../../core/elements/WHelpIcon';

interface DatenauswertungEnergiekennzahlenEmmissionProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
    standortTid: number;
    standortName: string;
    jahrFirst?: number;
    jahrLast?: number;
    setJSXdirect?: (content: JSX.Element) => void;
    callbackPages?: (pageNumber: number, totalPages: number) => void;
}

interface DatenauswertungEnergiekennzahlenEmmissionState {
    pdfString?: string;
    firstJahr: number;
    lastJahr: number;
    jahrMin: number;
    jahrMax: number;
    renderButton: JSX.Element;
}

export class DatenauswertungEnergiekennzahlenEmmission extends
    React.Component<DatenauswertungEnergiekennzahlenEmmissionProps, DatenauswertungEnergiekennzahlenEmmissionState> {

    constructor(props: any) {
        super(props);
        const data: any = props.data || {};
        const startjahr: number = ((data[IDs.ENT_KONFIGURATION] || [])[0] || {}).startjahr_datenerfassung || null;
        const jahrMax: number = new Date().getFullYear();
        let jahrMin: number = (data.first_year > 2009 && data.first_year < 2015) ? data.first_year : 2015;
        jahrMin = (startjahr > jahrMin) ? startjahr : jahrMin;
        this.state = {
            lastJahr: this.props.jahrLast || jahrMax - 1,
            firstJahr: this.props.jahrFirst || jahrMin,
            jahrMin: jahrMin,
            jahrMax: jahrMax,
            renderButton: undefined
        };
    }

    getValues(): any {
        const rows: any[] = [];
        const diag1: any[] = [];
        const diag2: any[] = [];
        const kennzahlen = this.props.standortTid
            ? this.props.data[IDs.KENNZIFFERN_BERECHNET_STANDORT][this.props.standortTid]
            : this.props.data[IDs.KENNZIFFERN_BERECHNET];
        const fn2wZ = (value: number) => (value || value === 0) ? fn2(value) : ' ';

        for (let jahr = this.state.firstJahr; jahr <= this.state.lastJahr; jahr++) {
            if (jahr === 2021) {
                // console.log('J2021', kennzahlen[jahr]);
            }
            const co2_strom = kennzahlen[jahr] && (kennzahlen[jahr].co2_strom_precalc || kennzahlen[jahr].co2_strom_precalc === 0)
                ? kennzahlen[jahr].co2_strom_precalc : null;
            const co2_waerme = kennzahlen[jahr] && (kennzahlen[jahr].co2_waerme || kennzahlen[jahr].co2_waerme === 0)
                ? kennzahlen[jahr].co2_waerme : null;
            const co2_kraftstoffe = kennzahlen[jahr] && kennzahlen[jahr].co2_kraftstoffe ? kennzahlen[jahr].co2_kraftstoffe : null;
            const co2_gesamt = kennzahlen[jahr] && kennzahlen[jahr].co2_emission ? kennzahlen[jahr].co2_emission : null;
            const mitarbeiter = kennzahlen[jahr] && kennzahlen[jahr].mitarbeiter ? kennzahlen[jahr].mitarbeiter : 0;
            // console.log(jahr, co2_gesamt, umsatz, co2_strom, co2_waerme, co2_kraftstoffe );
            const anteil_strom = co2_gesamt > 0 ? (100 / co2_gesamt) * co2_strom : 0;
            const anteil_waerme = co2_gesamt > 0 ? (100 / co2_gesamt) * co2_waerme : 0;
            const anteil_kraftstoffe = co2_gesamt > 0 ? (100 / co2_gesamt) * co2_kraftstoffe : 0;
            const anteil_mitarbeiter = mitarbeiter > 0 ? co2_gesamt / mitarbeiter : 0;
            const row = [
                jahr,
                fn2wZ(co2_strom), fn2wZ(co2_waerme), fn2wZ(co2_kraftstoffe), fn2wZ(co2_gesamt),
                fn2wZ(anteil_strom), fn2wZ(anteil_waerme), fn2wZ(anteil_kraftstoffe),
                mitarbeiter && mitarbeiter > 0 ? mitarbeiter : ' ', fn2nZ(anteil_mitarbeiter)
            ];
            const d1 = { jahr, co2_gesamt: co2_gesamt, co2: anteil_mitarbeiter };
            const d2 = { jahr, strom: anteil_strom, waerme: anteil_waerme, kraftstoff: anteil_kraftstoffe };

            if (rowHasValues(row)) {
                rows.push(row);
                if (co2_gesamt || anteil_mitarbeiter) {
                    diag1.push(d1);
                }
                if (anteil_strom || anteil_waerme || anteil_kraftstoffe) {
                    diag2.push(d2);
                }
            }
        }
        return { rows, diag1, diag2 };
    }

    render(): JSX.Element {
        const color: any = SectionStyle.getSectionColors() || {};
        const lineColor = [
            color.datenauswertung || '#4f81bd', color.zusatztools || '#f79646', color.dateneingabe || '#0a0', '#51bd75', '#5163bd',
            '#9951bd', '#bd5175', '#bd5151'
        ];
        // const style: any = { sub: getStyle('sub') };
        const numCols = 10;
        const baseWidth = 100 / numCols; // = 7.69% Bitte immer in Prozent angeben
        const unternehmen: string = ((this.props.data[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {}).name
            || (this.props.data.RES_MAIN_LOAD_UNTERNEHMEN_SEL || {}).bezeichnung || null;
        const values = this.getValues();
        const config: any = {
            titel0: unternehmen,
            titel1: i18n('Energiekennzahlen Emissionen CO₂', 'sys'),
            titel2: this.props.standortName,
            filename: `${i18n('Energiekennzahlen', 'sys')}_${i18n('Emissionen', 'sys')}_${this.state.firstJahr}_${this.state.lastJahr}.pdf`,
            report: {
                data: (this.props.data || {})[IDs.ENT_REPORT] || [], standort: +this.props.standortTid || 0, key: 'energiekennzahlen',
                sub: 'emissionen'
            },
            baseWidth: baseWidth,
            header: {
                title: i18n('Übersicht Berechnung', 'sys'),
                blocks: [
                    {
                        label: i18n('Jahr', 'sys'),
                        width: `${baseWidth}%`
                    },
                    {
                        label: i18n('CO₂-Emissionen', 'sys'),
                        width: `${baseWidth * 4}%`,
                        columns: [
                            { label: i18n('Strom', 'sys'), label2: 't', customStyleLabel2: { borderTop: '1pt solid #fff' } },
                            { label: i18n('Wärme', 'sys'), label2: 't', customStyleLabel2: { borderTop: '1pt solid #fff' } },
                            { label: i18n('Kraftstoff', 'sys'), label2: 't', customStyleLabel2: { borderTop: '1pt solid #fff' } },
                            { label: i18n('Gesamt', 'sys'), label2: 't', customStyleLabel2: { borderTop: '1pt solid #fff' } }
                        ]
                    },
                    {
                        label: i18n('Anteil an CO₂-Gesamtemissionen', 'sys'),
                        width: `${baseWidth * 3}%`,
                        columns: [
                            { label: i18n('Strom', 'sys'), label2: '%', customStyleLabel2: { borderTop: '1pt solid #fff' } },
                            { label: i18n('Wärme', 'sys'), label2: '%', customStyleLabel2: { borderTop: '1pt solid #fff' } },
                            { label: i18n('Kraftst.', 'sys'), label2: '%', customStyleLabel2: { borderTop: '1pt solid #fff' } }
                        ]
                    },
                    {
                        label: i18n('Anzahl{{lb}}Mitarbeitende', 'sys').replace('{{lb}}', '\n'),
                        width: `${baseWidth}%`,
                        columns: [
                            { label2: 'n' }
                        ]
                    },
                    {
                        label: i18n('CO₂-Emissionen/{{lb}}Mitarbeitende:r', 'sys').replace('{{lb}}', '\n'),
                        width: `${baseWidth}%`,
                        columns: [
                            { label2: 't' }
                        ]
                    }
                ]
            },
            rows: values.rows,
            row_classes: ['row_field_header', , , , 'row_field_dark', , , , , 'row_field_dark'],
            diagrams: [
                {
                    title: `${i18n('CO₂-Emissionen gesamt', 'sys')} & ${i18n('CO₂-Emissionen/Mitarbeitende:r', 'sys')}`,
                    titlePdf: `${i18n('CO₂-Emissionen gesamt', 'sys')} & ${i18n('CO₂-Emissionen/Mitarbeitende:r', 'sys')}`,
                    legend: [`${i18n('CO₂-Emission gesamt', 'sys')} [t]`, `${i18n('CO₂-Emission/Mitarbeitende:r', 'sys')} [t]`],
                    unit: ['t', 't'],
                    X_dataKey: 'jahr',
                    Y_dataKey: ['co2_gesamt', 'co2'],
                    data: values.diag1,
                    ignoreZeroData: true,
                    tickPeriod: [1, 50],
                    // singleYAxis: true,
                    lineColor,
                    containerSize: {
                        width: '90%'
                    }
                },
                {
                    type: 'StackedBarChartHorizontal', // Balkendiagramm
                    XTicks: [0, 20, 40, 60, 80, 100], // In Prozent
                    title: i18n('Anteil an CO₂-Gesamtemissionen', 'sys'),
                    titlePdf: i18n('Anteil an CO₂-Gesamtemissionen', 'sys'),
                    legend: [`${i18n('Strom', 'sys')} [%]`, `${i18n('Wärme', 'sys')} [%]`, `${i18n('Kraftstoff', 'sys')} [%]`],
                    unit: ['%', '%', '%'],
                    X_dataKey: 'jahr',
                    Y_dataKey: ['strom', 'waerme', 'kraftstoff'],
                    data: values.diag2.sort((a: any, b: any) => b['jahr'] - a['jahr']),
                    ignoreZeroData: true,
                    tickPeriod: [5, 5],
                    singleYAxis: true,
                    lineColor,
                    containerSize: {
                        width: '90%'
                    }
                }
            ]
        };
        const helpIcon = (
            <WHelpIcon
                data={this.props.data}
                styleDivProps={{ display: 'inline-block' }}
                styleProps={{ width: 18, height: 18, borderRadius: 10, backgroundColor: '#b9cde5', verticalAlign: 'top', margin: 0 }}
                label={i18n('Datenauswertung - Hinweise', 'sys')}
                helpKey='datenauswertung_emission'
                type='info'
                editBar
            />
        );
        const jahresauswahl: any = <DatenauswertungJahrauswahl
            jahrMin={this.state.jahrMin}
            jahrMax={this.state.jahrMax}
            jahrFirst={this.state.firstJahr}
            jahrLast={this.state.lastJahr}
            contextKey='datenauswertung'
            onFirstJahrChange={(jahr: number) => this.setState({ firstJahr: jahr })}
            onLastJahrChange={(jahr: number) => this.setState({ lastJahr: jahr })}
            renderClean={true}
            wrapClass={datenauswertungStyle.datenauswertungFormField}
        />;
        const arr_header_form_elements: any[] = [
            {
                elem: jahresauswahl,
                wrapClass: 'datenauswertungContentLeft',
                skipFormFieldWrapper: true
            },
            {   elem: isVeranstaltung(this.props.data, this.props.standortTid) ? this.renderVeranstaltung() : this.renderStandort(),
                wrapClass: 'datenauswertungContentGrow'
            },
            { elem: <span className={datenauswertungStyle.datenauswertungArrow}>🡆</span>, wrapClass: 'datenauswertungContentRight' },
            { elem: <><label>{i18n('Optionen', 'sys')}</label>{this.renderEingabeButton()}</>, wrapClass: 'datenauswertungContentRight' },
            { elem: <><label>&nbsp;</label>{this.renderBemerkungButton()}</>, wrapClass: 'datenauswertungContentRight' },
            { elem: <><label>&nbsp;</label>{this.state.renderButton}</>, wrapClass: 'datenauswertungContentRight' },
        ];
        return (
            <div>
                {!this.props.setJSXdirect &&
                    <div className={datenauswertungStyle.datenauswertungOuterFormContainer}>
                        {/*<DatenauswertungJahrauswahl
                            jahrMin={this.state.jahrMin}
                            jahrMax={this.state.jahrMax}
                            jahrFirst={this.state.firstJahr}
                            jahrLast={this.state.lastJahr}
                            contextKey='datenauswertung'
                            externalHeaderElements={[this.renderEingabeButton(), this.renderBemerkungButton(), this.state.renderButton]}
                            onFirstJahrChange={(jahr: number) => this.setState({ firstJahr: jahr })}
                            onLastJahrChange={(jahr: number) => this.setState({ lastJahr: jahr })}
                        />
                        <div style={{ padding: 5, paddingRight: 20 }}>{helpIcon}</div>
                        */}
                        <DatenauswertungFormWrapper
                            elements={arr_header_form_elements}
                        />
                    </div>
                }
                <DatenauswertungGenerisch
                    config={config}
                    orientation='landscape'
                    setRenderButton={(renderButton: JSX.Element) => this.setState({ renderButton })}
                    setJSXdirect={this.props.setJSXdirect}
                    callbackPages={typeof this.props.callbackPages === 'function' ? this.props.callbackPages : null}
                    pdfButtonStyle={{ backgroundColor: '#686868', color: '#fff' }}
                />
            </div>
        );
    }

    renderBemerkungButton(): JSX.Element {
        return (
            <DatenauswertungReportKonfigurationBemerkungButton
                data={this.props.data}
                standort={this.props.standortTid}
                type='energiekennzahlen'
                sub='emissionen'
                styleProps={{ backgroundColor: '#686868', color: '#fff' }}
                noLabel={true}
            />
        );
    }

    renderEingabeButton(): JSX.Element {
        const entities: string[] = [IDs.ENT_ENERGIEDATEN_STROM, IDs.ENT_ENERGIEDATEN_WAERME];
        return (
            <WActionButton
                label={i18n('Dateneingabe', 'sys')}
                insideText={i18n('zur E-Tool Eingabe wechseln', 'sys')}
                tooltip={i18n('zur E-Tool Eingabe wechseln', 'sys')}
                key='dateneingabe'
                action='editNote'
                styleProps={{ color: 'var(--color-button-text)', backgroundColor: 'var(--color-section-main)' }}
                onAction={() => this.props.onRoutingChange({
                    ...(getRoutingEnergiedaten(this.props.data, this.props.standortTid, entities) || {})
                })}
            />
        );
    }

    renderStandort(): JSX.Element {
        const disabled: boolean = this.props.data.MODUL_SELECTED === 'steuer';

        return (
            <StandortAuswahl
                label={i18n('Standort', 'sys')}
                data={this.props.data}
                standort={this.props.standortTid}
                disabled={disabled}
                filter={(standort: any, callback: (visible: boolean) => void) => {
                    const kennzahlen: any = (this.props.data[IDs.KENNZIFFERN_BERECHNET_STANDORT] || {})[standort.tid]
                        || this.props.data[IDs.KENNZIFFERN_BERECHNET] || {};
                    const flags: any = kennzahlen.flags || {};

                    if (typeof callback === 'function') {
                        callback(!!flags.hasKraftstoffe || !!flags.hasWaerme || !!flags.hasStrom);
                    }
                }}
                onStandortChange={(standort: number) => {
                    const basisRouting: any = RoutingIDs.ROUTE_DATENAUSWERTUNG_STANDORTE;
                    const basisTab: string = RoutingIDs.TABS_DATENAUSWERTUNG_STANDORTE;
                    const tabRoutings: any[] = getStandorteGruppenTabRoutings(this.props.data, basisRouting, basisTab, 2);
                    const path: any = (tabRoutings.find((item: any) => item?.dataRow?.tid === standort) || {}).path || {};
                    this.props.onRoutingChange({ path: { ...RoutingIDs.ROUTE_ENERGIEKENNZAHLEN_CO2_EMISSIONEN, ...path } });
                }}
                renderClean
            />
        );
    }

    renderVeranstaltung(): JSX.Element {
        return <>
            <label>{i18n('Standort', 'sys')}</label>
            <input type='text' value={this.props.standortName} disabled />
        </>;
    }
}
